module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/news/spinner/spinner.component.css
// module id = ./src/app/components/news/spinner/spinner.component.css
// module chunks = main